import type { FC, ReactNode } from "react";

import { MiniFlexTable } from "@similarweb/ui-components";

import { NoData } from "pro-features/components/NoData/src/NoData";
import { WidgetTitle } from "app/components/widget-title/WidgetTitle";
import { i18nFilter } from "app/filters/i18nFilter";
import { searchOverviewTopWidgetTableConfig } from "app/pages/website-analysis/traffic-sources/search/tabs/SearchOverviewTraffic/SearchOverviewTopWidgetTableConfig";
import { Separator } from "app/pages/website-analysis/traffic-sources/search/tabs/SearchOverviewTraffic/StyledComponent";
import {
    BoxContainer,
    SearchOverviewListContentWrapper,
    TitleContainer,
} from "app/pages/website-analysis/traffic-sources/search/tabs/SearchOverviewTraffic/TotalVisitsComponentsStyledComponents";
import { WidgetLoader } from "app/pages/website-analysis/traffic-sources/search/tabs/SearchOverviewTraffic/WidgetLoader";
interface DataTableProps {
    Data: [];
    TotalCount: number;
}
interface ISearchOverviewTopMiniFlexTableProps {
    data: DataTableProps;
    isLoading: boolean;
    isError: boolean;
    subtitleFilters: [];
    a2d?: () => ReactNode;
    tooltipKey: string;
    titleKey: string;
    fieldName: string;
    trendCall: any;
    displayName: string;
    addMarginRight?: boolean;
}
const i18n = i18nFilter();

export const SearchOverviewTopMiniFlexTable: FC<ISearchOverviewTopMiniFlexTableProps> = ({
    isLoading,
    isError,
    subtitleFilters,
    data,
    a2d,
    tooltipKey,
    titleKey,
    fieldName,
    trendCall,
    displayName,
    addMarginRight = true,
}) => {
    return (
        <>
            {isLoading ? <WidgetLoader /> : null}
            {!isLoading ? (
                <BoxContainer addMarginRight={addMarginRight}>
                    {isError ? <NoData subtitle={""} /> : null}
                    {!isError ? (
                        <>
                            <TitleContainer>
                                <WidgetTitle
                                    title={i18n(titleKey)}
                                    tooltip={i18n(tooltipKey)}
                                    filters={subtitleFilters}
                                    addToDashboard={a2d}
                                />
                            </TitleContainer>
                            <Separator />
                            <SearchOverviewListContentWrapper>
                                <MiniFlexTable
                                    data={data.Data}
                                    columns={searchOverviewTopWidgetTableConfig(fieldName, displayName, trendCall)}
                                    translations={{
                                        outOf: i18n("common.minitable.pager.out_of"),
                                        pages: i18n("Common.minitable.pager.pages"),
                                    }}
                                />
                            </SearchOverviewListContentWrapper>
                        </>
                    ) : null}
                </BoxContainer>
            ) : null}
        </>
    );
};
